<template>
	<section
		v-if="showConsent"
		class="fixed bottom-0 left-0 flex flex-row justify-between items-center h-auto w-full bg-black/90 text-white px-4 py-4 z-40"
	>
		<div class="font-normal">
			<p class="mr-2 md:mr-4 inline">{{ $t("cookieConsent.info") }}</p>
			<a
				:href="getDocumentUrl(LegalDocType.COOKIE, useRegion.getCurrentRegion().code, locale)"
				target="_blank"
				class="inline underline"
			>
				{{ $t("cookieConsent.moreInfo") }}
			</a>
		</div>
		<BaseButton
			class="capitalize md:text-sm lg:text-base transition-colors ml-4"
			type="primary"
			size="small"
			@click="acceptConsent"
		>
			{{ $t("cookieConsent.accept") }}
		</BaseButton>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { getDocumentUrl, LegalDocType } from "~/utils/legalDocs";

export default defineComponent({
	name: "CookieConsent",
	setup() {
		const { locale } = useI18n();
		const gtm = useGTM();
		const showConsent = ref(false);

		function acceptConsent() {
			showConsent.value = false;
			useCookie("cookieConsentAccepted", { maxAge: 2147483647 }).value = "true";

			// Enable GTM
			gtm.enable(true);

			// Save favourite job categories to cookie
			useCookie("favouriteJobCategories", { maxAge: 86400 }).value = String(
				useState("favouriteJobCategories").value || ""
			);
		}

		onMounted(() => {
			//Boolean(useCookie('cookieConsentAccepted').value) == true ? null :  showConsent.value = true
			gtm.enable(true);
			showConsent.value = false;
		});

		return {
			showConsent,
			acceptConsent,
			locale,
			getDocumentUrl,
			LegalDocType,
		};
	},
});
</script>
